var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"recaptcha-widget"}}),(_vm.renderError)?_c('div',[_vm._v("Fail to load recaptcha")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }